import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = ({ measurementId }) => {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', measurementId, {
      page_title: document.title,
      page_location: window.location.href,
    });

    return () => {
      // Cleanup script on unmount
      const scripts = document.head.querySelectorAll(`script[src*="googletagmanager"]`);
      scripts.forEach(script => script.remove());
    };
  }, [measurementId]);

  // Track page views on route changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', measurementId, {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location, measurementId]);

  return null;
};

// Analytics utility functions
export const trackEvent = (action, category, label, value) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

export const trackPageView = (path, title) => {
  if (window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_title: title,
      page_location: window.location.href,
      page_path: path,
    });
  }
};

export const trackConversion = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'conversion',
      ...parameters
    });
  }
};

export const trackFormSubmit = (formName, success = true) => {
  trackEvent('form_submit', 'engagement', formName, success ? 1 : 0);
};

export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', 'engagement', `${buttonName}_${location}`);
};

export const trackDownload = (fileName, fileType) => {
  trackEvent('file_download', 'engagement', fileName, fileType);
};

export const trackVideoPlay = (videoTitle, videoLocation) => {
  trackEvent('video_play', 'engagement', `${videoTitle}_${videoLocation}`);
};

export const trackDemoRequest = () => {
  trackConversion('demo_request', {
    event_category: 'lead_generation',
    event_label: 'demo_booking'
  });
};

export const trackTrialSignup = () => {
  trackConversion('trial_signup', {
    event_category: 'conversion',
    event_label: 'free_trial'
  });
};

export const trackPricingView = (plan) => {
  trackEvent('pricing_view', 'engagement', plan);
};

export const trackContactForm = () => {
  trackConversion('contact_form', {
    event_category: 'lead_generation',
    event_label: 'contact_inquiry'
  });
};

export default GoogleAnalytics;
